import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import {
    getFromLocalStorage,
    removeFromLocalStorage,
} from "../../services/helper/cl_Helper";
import { endpoints } from "../../api/ApiEndPoints";

const initialState = {
    phoneNumber: "",
    resetErrorMessage: "",
    phoneError: false,
    otpSuccess: false,
    resendOtp: false,
    pin: "",
    confirmPin: "",
    isLoading: false,
    mobileLoader: false,
    token: "",
    pinSuccess: false,
    resetOtp: "",
};

export const setPinSlice = createSlice({
    name: "setnewpin",
    initialState,
    reducers: {
        setResetErrorMessage: (state, action) => {
            state.resetErrorMessage = action.payload;
        },
        setPinError: (state, action) => {
            state.pinError = action.payload;
        },
        setPin: (state, action) => {
            state.pinError = action.payload;
        },
        setConfirmPin: (state, action) => {
            state.pinError = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setMobileLoader: (state, action) => {
            state.mobileLoader = action.payload;
        },
        setPinSuccess: (state, action) => {
            state.mobileLoader = action.payload;
        },
        setResetOtp: (state, action) => {
            state.resetOtp = action.payload;
        },
    },
});

export const {
    setPhoneNumber,
    setResetErrorMessage,
    setPhoneError,
    setPinError,
    setIsLoading,
    setMobileLoader,
    setPinSuccess,
    setResetOtp,
    setPin,
    setConfirmPin,
} = setPinSlice.actions;

export default setPinSlice.reducer;

export const handleSetPin = (otp, pin, navigate) => (dispatch) => {
    const token = getFromLocalStorage("gt");
    dispatch(setIsLoading(true));
    let url = endpoints?.setnewPin;
    const payload = {
        channelType: "mobile",
        otp: otp,
        password: pin,
        token: token,
    };
    console.log("payload: ", payload);
    postRequest(url, payload)
        .then((res) => {
            if (res?.data?.code === "1000") {
                dispatch(setIsLoading(false));
                dispatch(setPinSuccess(true));
                navigate("/");
                removeFromLocalStorage("gt");
            } else {
                dispatch(setIsLoading(false));
                dispatch(setPinSuccess(false));
                if (res?.data?.result?.message == "INVALID_OTP") {
                    dispatch(setResetErrorMessage("Please enter Valid OTP"));
                } else {
                    dispatch(setResetErrorMessage(res?.data?.result?.message));
                }
            }
        })
        .catch((err) => {
            dispatch(setIsLoading(false));
        });
};
